import { useEffect, useState } from 'react';

// RDS-PWA-CRM v2: banner persistente (no toast), contraparte clara del de
// Agenda. El CRM usa un sw.js escrito a mano -- este componente sigue
// escuchando el mismo evento custom 'shessai:sw-update-ready' que
// src/serviceWorker.js ya dispara desde el listener de 'controllerchange'
// EXISTENTE (no se tocó esa lógica en absoluto, solo cambia cómo se avisa).
//
// El "✕" solo cierra en memoria (setDismissed), sin persistir nada: si la
// versión sigue desactualizada, needRefresh vuelve a quedar en true en el
// próximo montaje de este componente (por ejemplo al navegar entre rutas
// que remontan el layout), así el banner reaparece solo -- nadie queda
// atascado en una versión vieja por haber cerrado el aviso una vez.
const UpdateBanner = () => {
  const [needRefresh, setNeedRefresh] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onUpdateReady = () => setNeedRefresh(true);
    window.addEventListener('shessai:sw-update-ready', onUpdateReady);
    return () => window.removeEventListener('shessai:sw-update-ready', onUpdateReady);
  }, []);

  if (!needRefresh || dismissed) return null;

  return (
    <div className="shessai-update-banner-container">
      <style>{`
        /* Las container queries no pueden apuntar al mismo elemento que
           declara container-type -- necesitan un ancestro contenedor y un
           descendiente que reaccione a su tamaño. Por eso el contenedor
           (que solo mide el ancho disponible) y el banner (que reacciona a
           esa medida) son dos elementos distintos, no el mismo div. */
        .shessai-update-banner-container { container-type: inline-size; }
        .shessai-update-banner {
          flex: none;
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 16px;
          background: #FFFFFF;
          color: #0B0F1A;
          border-bottom: 1px solid rgba(3,153,255,0.15);
          box-shadow: 0 1px 0 rgba(0,0,0,0.04);
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        }
        .shessai-update-banner-icon {
          width: 26px; height: 26px; border-radius: 8px; flex: none;
          background: linear-gradient(135deg, #0399FF, #00D9B5);
          display: flex; align-items: center; justify-content: center;
        }
        .shessai-update-banner-icon svg { width: 14px; height: 14px; color: #0B0F1A; }
        .shessai-update-banner-text { flex: 1; min-width: 0; font-size: 13px; font-weight: 500; }
        .shessai-update-banner-text .sub { font-size: 11px; opacity: 0.6; font-weight: 400; margin-top: 1px; }
        .shessai-update-banner-actions { display: flex; align-items: center; gap: 8px; flex: none; }
        .shessai-update-banner-btn {
          border: none; border-radius: 7px; padding: 7px 14px;
          font-family: inherit; font-size: 12.5px; font-weight: 700; cursor: pointer;
          background: linear-gradient(135deg, #0399FF, #00D9B5); color: #ffffff;
          white-space: nowrap;
        }
        .shessai-update-banner-close {
          width: 26px; height: 26px; border-radius: 7px; border: none; background: transparent;
          display: flex; align-items: center; justify-content: center; cursor: pointer; flex: none;
          opacity: 0.5; color: #0B0F1A; font-size: 13px;
        }
        @container (max-width: 400px) {
          .shessai-update-banner { flex-wrap: wrap; padding: 12px 14px; }
          .shessai-update-banner-text { flex: 1 1 100%; order: 1; }
          .shessai-update-banner-icon { order: 0; }
          .shessai-update-banner-actions { order: 2; flex: 1 1 100%; justify-content: flex-end; margin-top: 4px; }
        }
      `}</style>
      <div className="shessai-update-banner">
        <div className="shessai-update-banner-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
            <path d="M21 12a9 9 0 1 1-2.64-6.36" />
            <path d="M21 3v6h-6" />
          </svg>
        </div>
        <div className="shessai-update-banner-text">
          Hay una actualización disponible
          <div className="sub">Recarga para ver los últimos cambios</div>
        </div>
        <div className="shessai-update-banner-actions">
          <button
            type="button"
            className="shessai-update-banner-close"
            onClick={() => setDismissed(true)}
            aria-label="Cerrar aviso"
          >
            ✕
          </button>
          <button
            type="button"
            className="shessai-update-banner-btn"
            onClick={() => window.location.reload()}
          >
            Recargar
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateBanner;
